/**
 * PreviewServices — Service cards grid
 */

interface ServiceItem {
  icon?: string;
  title: string;
  text: string;
}

interface PreviewServicesProps {
  data: {
    title?: string;
    subtitle?: string;
    items?: ServiceItem[];
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewServices({ data, settings }: PreviewServicesProps) {
  return (
    <section className="preview-services" id="leistungen">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          <p>{data.subtitle}</p>
        </div>

        <div className="preview-services__grid">
          {data.items?.map((item, i) => (
            <div key={i} className="preview-service-card">
              <div className="preview-service-card__icon">
                {item.icon || "\uD83D\uDCCB"}
              </div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
